import { useState } from "react";
import { getDSRStatusLabel, getDSRStatusClass } from "../../constants/constants";

const ViewDSR = ({ dsr, onClose }) => {
  const [tab, setTab] = useState("report");

  if (!dsr) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content premium-profile" onClick={(e) => e.stopPropagation()}>

        <div className="page-header" style={{ marginBottom: 6 }}>
          <h2 style={{ fontSize: 18 }}>Daily Status Report</h2>
        </div>
        <hr className="premium-divider" />

        <div className="profile-tabs">
          <button className={tab === "report" ? "active" : ""} onClick={() => setTab("report")}>
            Report Details
          </button>
        </div>

        {tab === "report" && (
          <>
            <div className="profile-grid">
              <div className="profile-card">
                <label>Date</label>
                <span>{dsr.date || "—"}</span>
              </div>
              <div className="profile-card">
                <label>Status</label>
                <span className={`leaves-status ${getDSRStatusClass(dsr.status)}`}>
                  {getDSRStatusLabel(dsr.status)}
                </span>
              </div>
            </div>

            <div className="profile-card" style={{ marginTop: 16, gridColumn: "1 / -1" }}>
              <label>Report</label>
              <span style={{ fontWeight: 400, whiteSpace: "pre-wrap" }}>
                {dsr.report_text || "—"}
              </span>
            </div>
          </>
        )}

        <div className="employee-page-footer" style={{ padding: "22px 0 0", margin: "24px 0 0", justifyContent: "flex-end" }}>
          <div className="employee-actions">
            <button className="secondary" onClick={onClose}>Close</button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ViewDSR;